import { render, staticRenderFns } from "./BaseTableOrderCheckbox.vue?vue&type=template&id=ecf301e6"
import script from "./BaseTableOrderCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseTableOrderCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports